import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../actions';

class PaginationWrapper extends React.Component {
  constructor() {
    super();
    this.handleBackClick = this.handleBackClick.bind(this);
    this.handleNextClick = this.handleNextClick.bind(this);
    this.allowBackButton = this.allowBackButton.bind(this);
    this.allowNextButton = this.allowNextButton.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  allowBackButton() {
    return this.props.enabled && this.props.currentPage > 0;
  }

  allowNextButton() {
    return this.props.enabled && this.props.currentPage+1 < this.props.totalPages;
  }

  handleBackClick() {
    if(this.props.enabled && this.allowBackButton()) {
      let surveyId = notefit_config.survey_id;
      let eventId = notefit_config.event.id;
      this.props.switchToSurveyPage(this.props.currentPage-1, eventId, surveyId);
    }
  }

  handleNextClick() {
    if(this.props.enabled && this.allowNextButton()) {
      let surveyId = notefit_config.survey_id;
      let eventId = notefit_config.event.id;
      this.props.switchToSurveyPage(this.props.currentPage+1, eventId, surveyId);
    }
  }

  handleSubmit() {
    if(this.props.enabled) {
      let surveyId = notefit_config.survey_id;
      let eventId = notefit_config.event.id;
      let accountId = notefit_config.account != undefined ? notefit_config.account.id : null;
      this.props.submitSurvey(eventId, surveyId, accountId);
    }
  }

  render() {
    const { currentPage, totalPages, enabled, showPages } = this.props;
    const styleWrapper = {
      opacity: enabled ? 1 : .5,
      pointerEvents: enabled ? "auto" : "none"
    }
    return(
      <div className="survey-pagination-wrapper mb-shadow-box p1" style={styleWrapper}>
        <div className="survey-back-button">
          {this.allowBackButton() &&
            <button className="cs-btn-gray cs-jumbo-button" onClick={this.handleBackClick}>← Back</button>
          }
        </div>
        <div className="pagination-info-wrapper">
          {totalPages > 1 && showPages &&
            <div className="background-white br5 border-color-gray py1 px3 pagination-info">
              {currentPage+1} of {totalPages}
            </div>
          }
        </div>
        <div className="survey-next-button">
          {this.allowNextButton() &&
            <button className="cs-regular-blue-btn cs-jumbo-button" onClick={this.handleNextClick}>Next →</button>
          }
          {!this.allowNextButton() &&
            <button className="cs-regular-blue-btn cs-jumbo-button"  onClick={this.handleSubmit}>Submit</button>
          }
        </div>
      </div>

    )
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

PaginationWrapper.defaultProps = {
  showPages: true,
};

export default connect(null, mapDispatchToProps)(PaginationWrapper);
